var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.author
        ? [
            _c("ci-direct-message-modal", {
              attrs: {
                "user-id": _vm.author.id,
                "modal-id": `modal-direct-message--${_vm.author.id}`,
              },
            }),
          ]
        : _vm._e(),
      _vm.content.interest_tags && _vm.content.interest_tags.length
        ? _c("ci-interest-tags", {
            staticClass: "py-3",
            attrs: {
              "interest-tags": _vm.content.interest_tags,
              "tag-tracking-target-name": "TagArticleHeader",
              context: "articles",
              variant: "link",
            },
          })
        : _vm._e(),
      _c("h1", {
        staticClass: "article-details__headline word-break-word",
        attrs: { lang: _vm.languageTag },
        domProps: { textContent: _vm._s(_vm.content.title) },
      }),
      _vm.content.teaser && _vm.content.teaser.length
        ? _c("div", {
            staticClass: "article-details__teaser font-weight-bold py-3",
            attrs: { lang: _vm.languageTag },
            domProps: { innerHTML: _vm._s(_vm.content.teaser) },
          })
        : _vm._e(),
      _vm.event
        ? _c(
            "div",
            { staticClass: "article-details__social_event" },
            [
              _c("ci-social-event-tile", {
                attrs: {
                  context: "content",
                  "data-event": _vm.event,
                  variant: "light",
                  "with-border": true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.content.content_type === "Podcast" && _vm.content.media_id
        ? _c(
            "div",
            { staticClass: "article-details__cast" },
            [
              _c("ci-media-consent", {
                attrs: {
                  source: _vm.content.media_type,
                  "source-media-id": _vm.content.media_id,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.content.gated
        ? _c(
            "div",
            {
              staticClass: "article-details__text",
              attrs: { lang: _vm.languageTag },
            },
            [
              _vm.content.text && !_vm.content.is_short_news
                ? _c("CompileHtml", { attrs: { html: _vm.content.text } })
                : _vm._e(),
              _vm.content.is_short_news
                ? _c("a", {
                    staticClass: "contents-article__read-more",
                    attrs: { href: _vm.content.content_url, target: "_blank" },
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("ui.views.contents.article.read_more_on", {
                          url: _vm.content.content_url,
                        })
                      ),
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.content.disclaimer
        ? _c(
            "ci-foldable-text",
            {
              staticClass: "contents-article__disclaimer mt-3",
              attrs: { height: 50 },
            },
            [
              _c("small", {
                staticClass: "text-sm text-muted",
                domProps: { innerHTML: _vm._s(_vm.content.disclaimer) },
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }